import React from 'react';
import { ChevronDown } from 'lucide-react';

const ScrollIndicator = ({ className = '' }) => {
  const scrollToNext = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  return (
    <div 
      onClick={scrollToNext}
      className={`absolute left-0 right-0 bottom-8 mx-auto w-fit cursor-pointer animate-bounce ${className}`}
    >
      <div className="flex flex-col items-center space-y-2">
        <span className="text-sm text-slate-500">Scroll to explore</span>
        <ChevronDown className="w-6 h-6 text-slate-400" />
      </div>
    </div>
  );
};

export default ScrollIndicator;